import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
    * {
        appearance: none;
        -webkit-appearance: none;
        background-repeat: no-repeat;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    *:before,
    *:after {
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }

    label:not(.ecLabel), div.label {
        color: #7d7d7d;
        cursor: pointer;
        display: block;
        font-size: 1em;
        font-weight: 400;
        letter-spacing: 0;
        padding: 10px 0;
        margin: 0;
    }

    label:not(.ecLabel).required .labelText:after,
    div.label.required .labelText:after {
        color: ${props => props.theme.color.r500};
        content: ' *';
        display: inline;
        font-weight: normal;
    }

    label:not(.ecLabel).error input,
    label:not(.ecLabel).error select,
    label:not(.ecLabel).error textarea,
    div.label.error input,
    div.label.error select,
    div.label.error textarea {
        background-color: rgba(255, 0, 0, 0.1);
        border: 1px solid #f00;
        color: #f00;
    }

    label:not(.ecLabel).error input::placeholder,
    label:not(.ecLabel).error textarea::placeholder,
    div.label.error input::placeholder,
    div.label.error textarea::placeholder {
        color: #f00;
    }

    label:not(.ecLabel).error .msg,
    div.label.error .msg {
        color: #f00;
        display: block;
    }

    label:not(.ecLabel) .msg,
    div.label .msg {
        display: none;
        font-size: 0.8em;
        margin-top: 5px;
        text-transform: none;
    }

    input:not([type=file]):not([type=radio]):not([type=checkbox]):not([type=submit]):not(#ec-firstName):not(#ec-lastName):not(#ec-phone) {
        appearance: none;
        background-color: #fff;
        border: 1px solid #e6e6e6;
        border-radius: 0;
        color: #7d7d7d;
        display: block;
        font-family: "JD Sans", sans-serif;
        font-size: 1em;
        height: 40px;
        margin-top: 5px;
        outline: 0;
        padding: 5px 10px;
        width: 100%;
    }

    input[type=file] {
        display: block;
        margin-top: 10px;
    }

    input[type=date]::-webkit-inner-spin-button,
    input[type=date]::-webkit-clear-button {
        -webkit-appearance: none;
        display: none;
    }

    /** 
    * // TODO: Fix radio and checkbox styles 
    */
    input[type=radio] {
        -webkit-appearance: radio;
        vertical-align: middle;
        margin-right: 5px;
    }

    input[type=checkbox] {
        appearance: checkbox;
        border: 1px solid #e6e6e6;
        vertical-align: middle;
    }

    /* input[type="radio"]:checked {
        background-color: #7d7d7d;
    } */

    label:not(.ecLabel).error input:focus,
    label:not(.ecLabel).error textarea:focus,
    label:not(.ecLabel).error select:focus,
    div.label.error input:focus,
    div.label.error textarea:focus,
    div.label.error select:focus,
    input:not(#ec-firstName):not(#ec-lastName):not(#ec-phone):active,
    input:not(#ec-firstName):not(#ec-lastName):not(#ec-phone):focus,
    input:not(#ec-firstName):not(#ec-lastName):not(#ec-phone).filled,
    textarea:not(#ec-message):active,
    textarea:not(#ec-message):focus,
    textarea:not(#ec-message).filled,
    select:active,
    select:focus,
    select.filled {
        background-color: #fff;
        border: 1px solid #b7b7b7;
        color: #7d7d7d;
    }

    input[type=radio] {
        cursor: pointer;
    }

    textarea:not(#ec-message),
    select {
        background: #fff;
        border: 1px solid #e6e6e6;
        border-radius: 0;
        color: #7d7d7d;
        display: block;
        font-family: "JD Sans", sans-serif;
        font-size: 1em;
        margin-top: 5px;
        width: 100%;
    }

    textarea:not(#ec-message) {
        max-width: 100%;
        min-height: 100px;
        padding: 10px;
    }

    select {
        appearance: none;
        background-image: linear-gradient(45deg, transparent 50%, #7d7d7d 0),
            linear-gradient(135deg, #7d7d7d 50%, transparent 0);
        background-position: calc(100% - 16px) calc(1em + 2px), calc(100% - 12px) calc(1em + 2px), calc(100% - 2.1em) 0.5em;
        background-repeat: no-repeat;
        background-size: 5px 5px, 5px 5px, 1px 1.4em;
        height: 40px;
        padding: 5px 30px 5px 10px;
    }

    select::-ms-expand {
        display: none;
    }

    select option:first-child:disabled {
        color: #c9c9c9;
    }

    input:not(#ec-firstName):not(#ec-lastName):not(#ec-phone):required,
    textarea:not(#ec-message):required,
    select:required {
        box-shadow: none;
    }

    button,
    input[type=button],
    input[type=reset],
    input[type=submit] {
        -webkit-appearance: button;
    }

    button,
    select {
        text-transform: none;
    }

    input[type=search]::-webkit-search-cancel-button,
    input[type=search]::-webkit-search-decoration {
        -webkit-appearance: none;
    }

    .recaptcha {
        margin: 20px 0;
    }

    @media (min-width: 800px) {
        label:not(.ecLabel) {
            font-size: 0.9em;
            padding: 8px 0;
        }
    }
`
